export default "__VITE_ASSET__C9d7DaBb__"